module.exports = __webpack_public_path__ + "img/ivy-alt.f31eec78.png";